import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IApproveOrderPayload } from '@app-store/slices/subscriptionOrder/approve'

interface TaskAction extends Action {
    payload: IApproveOrderPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.orders.approve

function* approveOrderTask({ payload }) {
    try {
        const response = yield axios.get(`/subscriptions/orders/approve/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* approveOrderSaga(): any {
    yield takeLatest<TaskAction>(onRequest, approveOrderTask)
}

export default approveOrderSaga
